import { useSelector } from 'react-redux'
import { RootStore } from '../../redux/store'
import { LocationGroups } from '../../types/location-groups'

export const useIsSplitPotsForUk = (locationGroupName: string | undefined): boolean => {
  const splitPots = useSelector((state: RootStore) => state.featureToggles.splitPots)
  return splitPots && locationGroupName === LocationGroups.UK
}
